/* eslint-disable jsx-a11y/alt-text */
import { Box, Modal } from "@mui/material";
import '../LoadingModel/Loading.scss';
import invoiceLoaded from '../../assets/images/gif_Icons/invoiceLoaded.gif';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center',
  p: 4,
  display: 'grid',
  justifyContent: 'center',
};

function LoadingModal(props) {

  return (
    <>
      <Modal
        open={props.loading}
        custommodalbodystyle={{ background: "none", textAlign: "center" }}
      >
        <Box sx={style}>
          <div className={`container ${props.loading ? 'show-loader' : ''}`}>
            <div>

              <div className="loader">
                <img src={invoiceLoaded} width={40} height={40} />
                <div className="loader--dot"></div>
                <div className="loader--dot"></div>
                <div className="loader--dot"></div>
                <div className="loader--dot"></div>
              </div>
            </div>

          </div>
        </Box>
      </Modal>
    </>
  );
}

export default LoadingModal;
